import React from "react";
import MetersView from "../../../views/dashboard/meters";

const Meters = () => {
  return <MetersView />;
};

export default Meters;
